module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "alert-box"
  }, [_c('div', {
    staticClass: "alert-left"
  }, [(_vm.options.msgIsSuccess) ? _c('i', {
    staticClass: "icon icon-success"
  }) : _c('i', {
    staticClass: "icon icon-error"
  })]), _vm._v(" "), _c('div', {
    staticClass: "alert-right"
  }, [_vm._v("\n      " + _vm._s(_vm.options.msgText) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-34e603e0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/alert.vue
// module id = iuoQ
// module chunks = 15